module.exports = __webpack_public_path__ + "media/images/flags/16/Rwanda-6c57bb2012e9057c03d4f4d36d4d657b.png";